export const TIER_LEVELS = {
  free: 0,
  professional: 1,
}

export function getTierLevel(tier: string): number {
  return TIER_LEVELS[tier as keyof typeof TIER_LEVELS] ?? 0;
}

export function hasAccess(userTier: string, requiredTier: string): boolean {
  return (getTierLevel(userTier) >= getTierLevel(requiredTier));
}

export function formatTierName(tier: string): string {
  return tier.charAt(0).toUpperCase() + tier.slice(1);
}
